import React from "react";
import CreateEditProduct from "./CreateEditProduct";

function ProductsAddEditManage({ productid }) {
  return (
    <React.Fragment>
      <div className="container-fluid overflow-hidden" style={{ paddingLeft: "15px", paddingRight: "0px", paddingTop: "10px", paddingBottom: "0px"}}>
        <CreateEditProduct productid={productid} />
      </div>
    </React.Fragment>
  );
}

export default ProductsAddEditManage;
